<template>
    <div class="grid-content">
        <div class="grid-item grid-item-full" v-for="(instrument, index) in methods" :key="index">
            <v-radio
                group="paymentTypes"
                :label="instrument.label"
                :value="instrument.value"
                :model="value"
                @update="$emit('input', $event)"/>
        </div>
    </div>
</template>

<script>
    import vRadio from '@/components/form/v-radio';

    export default {
        name: 'select-payment-method',
        props: {
            methods: Array,
            value: String,
        },
        components: {vRadio},
    };
</script>
